{
  "title": "如何建立或加入隊伍",
  "description": "在競賽中建立一支新隊伍，或透過隊長提供的邀請連結加入既有隊伍。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您會成為某支隊伍的成員（建立者為隊長），可以開始填寫報名與作品表單。",
  "roleNote": "參賽者",
  "prerequisites": [
    "已註冊並完成 Email 驗證",
    "該場競賽的報名時程尚未結束",
    "目前尚未加入該場競賽的任何隊伍"
  ],
  "pathLabel": "競賽詳情頁 → 隊伍",
  "steps": [
    {
      "title": "1. 建立隊伍",
      "description": "在競賽詳情頁選擇一個組別後點選「建立隊伍」，輸入隊伍名稱送出；建立者自動成為隊長。同一場競賽中，非指導老師身分的帳號最多只能屬於一支隊伍。"
    },
    {
      "title": "2. 產生邀請連結（隊長）",
      "description": "隊長可在隊伍頁面產生邀請連結，分享給預定的隊員；也可以改用 Email 邀請，系統會寄出通知。"
    },
    {
      "title": "3. 加入隊伍（隊員）",
      "description": "點擊隊長提供的邀請連結後，系統會先顯示競賽、團隊與邀請者資訊；開啟連結本身不會直接把你加入團隊。若尚未登入，先登入或建立帳號，完成後系統會帶你回到邀請頁。確認資訊無誤後，選擇「接受邀請並加入」才會真正完成加入。連結若已過期、被撤銷、或已達使用上限，畫面會顯示對應原因，需請隊長重新產生；若你已加入這場競賽的另一個團隊，必須先處理目前的團隊關係才能接受其他團隊的邀請。"
    }
  ],
  "afterward": [
    "您出現在隊伍成員清單中",
    "隊長可在隊伍頁面看到目前所有成員",
    "可以開始填寫報名與作品表單"
  ],
  "nextSteps": "接著可以前往報名表單，依競賽要求填寫報名資訊。",
  "faq": [
    {
      "q": "可以同時加入兩支隊伍嗎？",
      "a": "不行。同一場競賽中，非指導老師身分的帳號最多只能有一個有效的隊伍身分。若需要更換隊伍，請先確認原隊伍狀態，或聯絡主辦方協助處理。"
    },
    {
      "q": "只有隊長可以編輯隊伍資料嗎？",
      "a": "編輯隊伍資料（含產生邀請連結）需要隊長身分，或具有該競賽 staff 權限且被授予隊伍管理權限的工作人員；一般隊員可以查看與協作填寫表單，但無法變更隊伍本身的設定。"
    }
  ]
}
